module.exports = __webpack_public_path__ + "static/edge-logo-5bc62347ea8816e0d09e237e5606fdc8.png";